import React, { useEffect, useState } from "react";
import "./index.scss";
import { Box, Select, MenuItem, Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AsyncLocalStorage from "@createnextapp/async-local-storage";
import { branchKeys } from "api/queries/useBranch";
import { staffKeys } from "api/queries/useStaff";
import { queryClient } from "utilities/queryClient";
import { getUserPermissions } from "../../../store/actions/aclUserPermissions";
import { getUser } from "../../../store/actions/user";

function BranchSelect() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const defaultBranch = useSelector((state) => state.branch.data);
  const client = useSelector((state) => state.client.clients);
  const { data: userAccessLevel } = useSelector((state) => state.aclUserPermissions);
  const [selectedBranch, setSelectedBranch] = useState(defaultBranch);
  const [currentLocation, setCurrentLocation] = useState("");

  const getClientBranch = () => {
    let branches = [];
    let key = 0;
    if (client) {
      client.forEach((element) => {

        let address = element.address
        if (address.length > 10) {
          address = address.substring(0, 9) + "...";
        }

        branches.push({
          key: key++,
          text: element.name,
          value: element?.id,
          title: element.address,
          content: (
            <Box>
              <Typography variant="body2">{element.name}</Typography>
              <Typography variant="caption" color="text.secondary">{`${address}/${element.pin_code}`}</Typography>
            </Box>
          ),
        });
      });
    }
    return branches;
  };

  useEffect(() => {
    async function initialFunc() {
      let adminBranch = await AsyncLocalStorage.getItem("adminBranch");
      setSelectedBranch({ id: adminBranch });
    }
    initialFunc();
  }, []);

  useEffect(() => {
    setCurrentLocation(location.pathname);
  }, [location.pathname]);

  const onBranchChange = async (value) => {
    try {
      await AsyncLocalStorage.setItem("adminBranch", value);
      setSelectedBranch({ id: value });
      // Permissions (and everything derived from them -- the sidebar, branch
      // data, subscriptions) are only fetched once on login, not on
      // navigation, so switching branches here would otherwise leave the
      // sidebar showing the previous branch's permissions until a full
      // reload. Re-fetching explicitly updates state.aclUserPermissions,
      // which cascades through App.js's own effect into branch/loyalty/
      // client/subscription data too.
      dispatch(getUserPermissions());
      // state.user carries branch-dependent fields (e.g. staff_attendance_punch),
      // and useBranch/useStaff/useBasicStaff are cached by React Query with no
      // branch dimension in their query keys -- the axios interceptor changes
      // ?branch_id= transparently at the HTTP layer, so without this React
      // Query has no way to know the previous branch's cached data is now
      // stale, and getUser() would otherwise only ever run once at mount.
      dispatch(getUser());
      queryClient.invalidateQueries({ queryKey: branchKeys.all });
      queryClient.invalidateQueries({ queryKey: staffKeys.all });
      history.replace("/pageload");
      setTimeout(() => {
        history.replace(currentLocation);
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="branch-selector">
      {userAccessLevel.formatted_component_permissions.includes("admin_access") ? (
        <Box>
          <Select
            displayEmpty
            value={selectedBranch?.id || ""}
            onChange={(e) => {
              onBranchChange(e.target.value);
            }}
            size="small"
            renderValue={(selected) => {
              const branches = getClientBranch();
              const found = branches.find((b) => b.value === selected);
              return found ? found.text : "Select Branch";
            }}
          >
            {getClientBranch().map((branch) => (
              <MenuItem key={branch.key} value={branch.value} title={branch.title}>
                {branch.content || branch.text}
              </MenuItem>
            ))}
          </Select>
        </Box>
      ) : (
        ""
      )}
    </div>
  );
}
export default BranchSelect;
